/* global axios */
import ApiClient from './ApiClient';

class BusinessConnectorsAPI extends ApiClient {
  constructor() {
    super('business_connectors', { accountScoped: true });
  }

  test(id, customer, connector) {
    const endpoint = id ? `${this.url}/${id}/test` : `${this.url}/test`;
    return axios.post(endpoint, { ...customer, connector });
  }

  conversationUrl(id) {
    return `${this.baseUrl()}/conversations/${id}/business_customers`;
  }

  profiles(id) {
    return axios.get(this.conversationUrl(id));
  }

  lookup(id, data) {
    return axios.post(`${this.conversationUrl(id)}/lookup`, data);
  }

  bind(id, data) {
    return axios.post(`${this.conversationUrl(id)}/link`, data);
  }

  unbind(id, connectorId) {
    return axios.post(`${this.conversationUrl(id)}/unlink`, {
      connector_id: connectorId,
    });
  }
}

export default new BusinessConnectorsAPI();
